import { noAuto } from "@fortawesome/fontawesome-svg-core";
import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  Image,
  View,
} from "@react-pdf/renderer";
import * as React from "react";
import moment from "moment";

import { IPdflink } from "../../types/interfaces";
import { getEncModeRegl } from "../../services/misc";
import { constants } from "../../types/constants";

Font.register({
  family: 'Open Sans',
  fonts: [
  { src: '/fonts/open-sans-regular.ttf' },
  { src: '/fonts/open-sans-italic.ttf', fontStyle: "italic" },
  { src: '/fonts/open-sans-600italic.ttf', fontWeight: 600, fontStyle: "italic" },
  { src: '/fonts/open-sans-600.ttf', fontWeight: 600 },
  { src: '/fonts/open-sans-300.ttf', fontWeight: 300 }
  ]
});

const MyDocument: any = Document
const MyPage: any = Page

const DechargeDocument: React.FC<IPdflink> = ({ documentType, data, showPreviewWatermark, title, fileObject }: IPdflink) => {
  if(!data)
    return (<MyDocument>
      <MyPage size="A4">
        <View>
          <Text>Erreur 968</Text>
        </View>
      </MyPage>
    </MyDocument>)
  
  const PAGE_SIDE_PADDING = 40,
    BORDER_COLOR = '#bfbfbf',
    BORDER_STYLE = 'solid',
    columns: any[] = [{value: "Nom sur Chèque", width: "12.5%", subWidth: "25%", bgColor: "darkred"}, {value: "Référence", width: "12.5%", subWidth: "25%", bgColor: "darkred"}, {value: "Montant", width: "12.5%", subWidth: "25%", formatNumber: true, bgColor: "darkred"}, {value: "Date CHQ", width: "12.5%", subWidth: "25%", bgColor: "darkred"}, {value: "Observation", width: "50%"}],
    replacedEncs = (data.enc_sorti_lines || []).filter(e => !e.isReplacer).map(e => e.encaissement).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index),
    replacerEncs = (data.enc_sorti_lines || []).filter(e => e.isReplacer).map(e => e.encaissement).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index);
  
  const styles = StyleSheet.create({
    body: {
      padding: PAGE_SIDE_PADDING
    },
    logoContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 15
    },
    middleLogoContainer1: {
      flex: 7
    },
    middleLogoContainer2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans'
    },
    clientTitleContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 20
    },
    clientTitleView1: {
      width: "100%"
    },
    clientTitleView2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      marginVertical: 6,
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans',
      textAlign: "center",
      fontSize: 18,
      backgroundColor: "#fefefe",
    },
    middleLogoText: {
      width: "100%",
      // flex: 1,
      textAlign: "center",
      fontSize: 22,
      fontWeight: 600,
      textTransform: "uppercase"
    },
    middleLogoTextTop: {
      alignItems: "flex-end"
    },
    middleLogoTextBottom: {
      alignItems: "flex-start"
    },
    table: { 
      // display: "table", 
      width: "auto", 
      fontFamily: 'Open Sans',
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderRightWidth: 0, 
      borderBottomWidth: 0,
      marginBottom: 15
    },
    tableRow: { 
      margin: "auto", 
      flexDirection: "row" 
    },
    // footerRow: { 
    //   marginLeft: COL1_WIDTH + '%', 
    //   flexDirection: "row" 
    // },
    headerCol: { 
      backgroundColor: "#62af42",
      color: "white",
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderBottomColor: 'green',
      borderWidth: 1,
      fontWeight: 600,
      textAlign: "center"
    },
    rowCol: { 
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      textAlign: "center",
      fontFamily: 'Open Sans',
      fontWeight: 300,
      // borderLeftWidth: 0,
      // borderTopWidth: 0 
    },
    footerCol: {
      backgroundColor: "#62af42",
      color: "white",
      fontWeight: 600
    },
    cellText: { 
      marginVertical: 5,
      // marginHorizontal: 2,
      textAlign: "center",
      fontSize: 8
    },
    headerText: {
      fontWeight: 600
    },
    logo: {
      height: "auto",
      flex: 1
    },
    dateFournisseurView: {
      color: "#555555",
      fontSize: 12,
      // width: "100%",
      fontFamily: 'Open Sans',
      justifyContent: "flex-end",
      flexDirection: "row",
      marginBottom: 10
    },
    bvView: {
      color: "#000000",
      fontSize: 11,
      fontFamily: 'Open Sans',
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginBottom: 10
    },
    titlesView: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginTop: 7,
      marginBottom: 7
    },
    cardContainer1: {
      color: "#000000",
      fontSize: 10,
      fontFamily: 'Open Sans',
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginBottom: 10
    },
    cardContainer2: {
      // display: "table",
      width: "100%"
    },
    clientCardContainer: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      fontFamily: 'Open Sans',
      color: "#000000",
      fontSize: 11,
    },
    cardRow: {
      width: "100%",
      flexDirection: "row",
      // marginBottom: 4,
      marginVertical: 2,
      paddingVertical: 0,
    },
    cardCellTitle: {
      fontStyle: "italic",
      width: "20%"
    },
    cardCellValue: {
      fontWeight: 600,
      width: "20%"
    },
    cardCellSpace: {
      width: "20%"
    },
    clientCardCellTitle: {
      fontWeight: 600,
      borderRightWidth: 2,
      borderRightColor: "green",
      borderRightStyle: "solid",
      paddingHorizontal: 6,
      paddingVertical: 8,
      borderBottomWidth: 1,
      borderBottomColor: "rgb(172, 210, 172)",
      borderBottomStyle: "solid",
      backgroundColor: "#f2f2f2",
      flex: 1
    },
    clientCardCellValue: {
      fontStyle: "italic",
      paddingHorizontal: 6,
      paddingVertical: 8,
      borderBottomWidth: 1,
      borderBottomColor: "rgb(172, 210, 172)",
      borderBottomStyle: "solid",
      backgroundColor: "#fefefe",
      flex: 1
    },
    arreteView: {
      color: "#333333",
      fontSize: 10,
      fontStyle: "italic",
      fontFamily: 'Open Sans',
      width: "100%",
      marginTop: 20
    },
    directionText: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      marginLeft: "70%",
      marginTop: 25
    },
    textMargin: {
      marginBottom: 4
    },
    watermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      transform: "rotate(-60deg)",
      fontSize: 50,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .1
    },
    previewWatermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      fontSize: 80,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .4
    },
    borderTest: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "green"
    },
    borderTest2: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "red"
    },
    pageCountContainer: {
      position: "absolute",
      bottom: 14,
      left: PAGE_SIDE_PADDING,
      paddingTop: 8,
      paddingBottom: 8,
      width: "100%",
      color: "#333333",
      fontSize: 8
    },
    pageCountText: {
      textAlign: "center",
      marginBottom: 4
    },
    lastElement: {
      marginBottom: 0,
      paddingBottom: 0
    },
    mainTitle: {
      color: "green",
      fontFamily: 'Open Sans',
      fontWeight: 600,
      width: "100%",
      fontSize: 25,
      // fontSize: fontSizeFactor === 1 ? 20 : fontSizeFactor === 2 ? 22 : fontSizeFactor === 3 ? 24 : fontSizeFactor === 4 ? 25 : fontSizeFactor === 5 ? 26 : 25,//25
      textDecoration: "underline",
      justifyContent: "center",
      flexDirection: "row",
      marginBottom: 5
    },
    signCol: {
      fontFamily: 'Open Sans',
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderWidth: 1,
    },
  });
  return (
  <MyDocument creator={"ayoub laazazi"} producer={"producer"} title={title} author={"ayoub laazazi"}>
    <MyPage size="A4" orientation="landscape" style={{...styles.body, position: "relative"}}>
      <View style={styles.watermark} fixed>
        {/* <Text>{fileObject && fileObject.toUpperCase()}</Text> */}
        <Text>{""}</Text>
      </View>
      {showPreviewWatermark ? <View style={styles.previewWatermark} fixed>
        <Text>Aperçu</Text>
      </View> : null}

      <View fixed>
        <View style={styles.logoContainer}>
          <Image src={`/images/icon.png`} style={styles.logo}/>
          <View style={styles.middleLogoContainer1}>
            <View style={styles.middleLogoContainer2}>
              <Text style={{...styles.middleLogoText, ...styles.middleLogoTextTop}}>
                SHEMS AL MADINA
              </Text>
              <Text style={{...styles.middleLogoText, ...styles.middleLogoTextBottom}}>
                {data.contrat?.PROJET || "---"}
              </Text>
            </View>
          </View>
          <Image src={`/images/icon.png`} style={styles.logo}/>
        </View>
      </View>

      <View style={{...styles.mainTitle, fontSize: 22}}>
        <Text>
          Chèques à récupérer
        </Text>
      </View>

      <View style={{...styles.mainTitle, fontSize: 16}}>
        <Text>
          Lot N° {data.contrat?.NUM_DOSS || "???"} {data.contrat?.TRANCHE ? ` T-${data.contrat.TRANCHE}` : ""}
        </Text>
      </View>
      
      <View style={{marginTop: 15}}>
        <View style={{...styles.table, ...styles.lastElement}}>
          <View style={styles.tableRow} wrap={false}>
            {columns.map((e, key) => 
              <View style={{...styles.headerCol, width: e.width + "%", ...(e.bgColor ? {backgroundColor: e.bgColor} : {})}} key={key}>
                <Text style={{...styles.cellText, ...styles.headerText}}>{ e.value }</Text>
              </View>
            )}
          </View>
          <View style={styles.tableRow} wrap={false}>
            <View style={{...styles.rowCol, width: "50%", display: "flex", flexDirection: "column"}}>
              {replacedEncs.map((encaissement, encaissementKey) => <View key={encaissementKey} style={{...styles.tableRow, width: "100%"/*, backgroundColor: encaissementKey === 0 ? "orange" : "cyan"*/}} wrap={false}>
                {columns.filter((_, i, a) => i !== a.length - 1).map((_, key) => {
                  let e: any = ""
                  switch(key){
                    case 0: e = encaissement.TIRE_PAR || "-"; break;
                    case 1: e = encaissement.REF_REGLEMENT || "-"; break;
                    case 2: e = Number(encaissement.MONTANT) || 0; break;
                    case 3: e = encaissement.DATE_PORTEFEUILLE ? moment(encaissement.DATE_PORTEFEUILLE).format('DD/MM/YYYY') : "-"; break;
                  }
                  return <View style={{...styles.rowCol, borderBottomWidth: replacedEncs.length > 1 ? 1 : 0, borderLeftWidth: key === 0 ? 0 : 1, borderRightWidth: 0, borderTopWidth: 0, width: columns[key].subWidth + "%"}} key={key}>
                    <Text style={styles.cellText}>{ (e = e || 0, columns[key].formatNumber ? `${Number(e).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} DH` : columns[key].isDecimal ? Number((+e).toFixed(2)) : e) }</Text>
                  </View>
                })}
              </View>)}
            </View>

            <View style={{...styles.rowCol, width: "50%", display: "flex", flexDirection: "column", justifyContent: "center", paddingVertical: 3}}>
              <View style={{/*flex: 1, */alignItems: "center", justifyContent: "center"/*, backgroundColor: "red"*/, display: "flex"}}>
                <Text style={{...styles.cellText, marginVertical: 2}}>{replacerEncs.length > 0 ? `Remplacé${replacedEncs.length > 1 ? "s" : ""} par:` : `Récupéré${replacedEncs.length > 1 ? "s" : ""}`}</Text>
                {replacerEncs.map((e, key) => <Text key={key} style={{...styles.cellText, marginVertical: 2}}>{getEncModeRegl(e.MODE_REGL)} — N° {e.REF_REGLEMENT} — ({e.DATE_PORTEFEUILLE ? moment(e.DATE_PORTEFEUILLE).format('DD/MM/YYYY') : "-"}) — {`${Number(e.MONTANT || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} DH`}</Text>)}
              </View>
            </View>
          </View>
        </View>
      </View>

      <View style={{flexDirection: "row", justifyContent: "flex-end", fontSize: 8, fontWeight: 600, fontFamily: 'Open Sans', marginTop: 10}}>
        <Text style={{fontWeight: 600, fontFamily: 'Open Sans'/*, textDecoration: "underline"*/}}>Edité le : {moment().format('DD/MM/YYYY')}</Text>
      </View>

      <View style={{width: "100%", display: "flex", justifyContent: "center", flexDirection: "row", marginTop: 20}}>
        <View style={{flex: "0 0 40%"}}>
          <View style={{...styles.signCol}}>
            <Text style={{fontSize: 9, padding: 2, textAlign: "center", fontWeight: 600, backgroundColor: "#62af42", color: "white"}}>Signature</Text>
          </View>
          <View style={{...styles.signCol, height: 100}}>
            <Text style={{fontSize: 9, margin: 2, textAlign: "center"}}></Text>
          </View>
          <View style={{...styles.signCol}}>
            <Text style={{fontSize: 9, margin: 2, textAlign: "center"}}>Signé le: ____/____/________</Text>
          </View>
        </View>
      </View>

      <View style={styles.pageCountContainer} fixed>
        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => totalPages > 1 && `${pageNumber} / ${totalPages}`} fixed />
      </View>
    </MyPage>
  </MyDocument>
  )
};

export default DechargeDocument;
